

import {Component, Prop, PropSync, Vue} from "vue-property-decorator"
import {NavigationLink} from "@/types/NavigationLinks.ts";

@Component
export default class NavigationDrawer extends Vue {

  @PropSync("drawer")
  _drawer!: boolean;

  @Prop()
  links!: Array<NavigationLink>;

  openLink(link: string): void {
    window.open(link, "_blank")
  }

}
